/** @format */

import React, { Component } from 'react';
import { Menu, Icon } from 'semantic-ui-react';

class AppSideMenuItem extends Component {
  render() {
    return (
      <Menu.Item
        active={this.props.active}
        as="a"
        name={this.props.name}
        onClick={(e, input) => {
          this.props.handleSideItemClick(this.props.name, this.props.link);
        }}
      >
        <Icon name={this.props.icon} />
        {this.props.text}
      </Menu.Item>
    );
  }
}

export default AppSideMenuItem;
